module.exports = __webpack_public_path__ + "img/info_banner4.2c3f7ea.jpg";